var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-wrapper"},[_c('div',{class:{ 'stepper-item completed': true }},[_c('div',{staticClass:"step-counter"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}})],1),_c('div',{staticClass:"step-name"},[_vm._v(_vm._s(_vm.setName("RESERVADO")))])]),(_vm.customerId !== 146)?_c('div',{class:{
      'stepper-item': true,
      completed: [
        'PROMESADO',
        'ESCRITURADO',
        'ENTREGADO',
        'POSTVENTA',
      ].includes(_vm.apartment.asset_state),
    }},[_c('div',{staticClass:"step-counter"},[(
          ['PROMESADO', 'ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
            _vm.apartment.asset_state
          )
        )?_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}):(['RESERVADO'].includes(_vm.apartment.asset_state))?_c('font-awesome-icon',{staticClass:"fa-spin",staticStyle:{"--fa-animation-iteration-count":"5"},attrs:{"icon":['far', 'hourglass']}}):(_vm.country == 1)?[_vm._v("2")]:_vm._e()],2),_c('div',{staticClass:"step-name"},[_vm._v(_vm._s(_vm.setName("PROMESADO")))])]):_vm._e(),(_vm.country == 1)?_c('div',{class:{
      'stepper-item': true,
      completed: ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
        _vm.apartment.asset_state
      ),
    }},[_c('div',{staticClass:"step-counter"},[(
          ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
            _vm.apartment.asset_state
          )
        )?_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}):(['PROMESADO'].includes(_vm.apartment.asset_state))?_c('font-awesome-icon',{staticClass:"fa-spin",staticStyle:{"--fa-animation-iteration-count":"5"},attrs:{"icon":['far', 'hourglass']}}):(_vm.country == 1)?[_vm._v("3")]:_vm._e()],2),_c('div',{staticClass:"step-name"},[_vm._v(_vm._s(_vm.setName("ESCRITURADO")))])]):_vm._e(),_c('div',{class:{
      'stepper-item': true,
      completed: ['ENTREGADO', 'POSTVENTA'].includes(_vm.apartment.asset_state),
    }},[_c('div',{staticClass:"step-counter"},[(['ENTREGADO', 'POSTVENTA'].includes(_vm.apartment.asset_state))?_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}):(
          (_vm.country == 1
            ? ['ENTREGADO']
            : ['PROMESADO', 'ENTREGADO']
          ).includes(_vm.apartment.asset_state)
        )?_c('font-awesome-icon',{staticClass:"fa-spin",staticStyle:{"--fa-animation-iteration-count":"5"},attrs:{"icon":['far', 'hourglass']}}):(_vm.country == 1)?[_vm._v("4")]:_vm._e()],2),_c('div',{staticClass:"step-name"},[_vm._v(_vm._s(_vm.setName("ENTREGADO")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }